import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const HeartSolidIcon = ({
    size = 16,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path d="M14.447 1.956c-1.713-1.46-4.26-1.197-5.831.425L8 3.016l-.616-.635C5.816.76 3.266.497 1.554 1.956-.41 3.631-.514 6.638 1.243 8.453l6.047 6.244a.98.98 0 0 0 1.415 0l6.047-6.244c1.76-1.815 1.656-4.822-.306-6.497Z"/>
    </svg>
);
HeartSolidIcon.displayName = 'HeartSolidIcon';
export default HeartSolidIcon;
